var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path27, _path28, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path29, _path30, _path31, _rect18, _path32, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCotatoCharacterPm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 234,
    viewBox: "0 0 225 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8227 26.0977H139.182V34.2651H148.869L148.869 50.5998H158.046V82.2485H168.243V102.667H178.439V143.504H168.243V169.027H158.046V177.195H148.869L148.869 185.362H139.182V185.452H138.578V193.776H49.6975V185.452H39.8227V177.127H29.9485V34.4216H39.8227V26.0977ZM20.0704 51.0714H29.9453V152.154H20.0704V51.0714ZM20.0692 80.8019H10.1943V143.83H20.0692V80.8019ZM59.5717 193.777V202.101H128.701V193.777H59.5717Z",
    fill: "#D59F52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.507 0.574219H60.664V8.89869H118.507V0.574219Z",
    fill: "#1A1918"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.382 201.696H59.2532V209.875H128.382V201.696Z",
    fill: "#1A1918"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.944 16.909H39.767V26.0973H49.3776L48.944 16.909Z",
    fill: "#1A1918"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.382 17.2232H138.258V26.0973H128.382V17.2232Z",
    fill: "#1A1918"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.507 8.89869H128.382V17.2232H118.507V8.89869Z",
    fill: "#1A1918"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.944 8.89869H60.664V17.2232L48.944 16.909V8.89869Z",
    fill: "#1A1918"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.767 26.0973H29.6264V34.2647H39.767V26.0973Z",
    fill: "#1A1918"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.258 26.0973H148.133V34.2647H138.258V26.0973Z",
    fill: "#1A1918"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6264 34.2647H19.7508V50.5211H29.6264V34.2647Z",
    fill: "#1A1918"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7508 50.5211H9.87524V80.2514H19.7508V50.5211Z",
    fill: "#1A1918"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.133 34.2647H158.009V50.5995H148.133V34.2647Z",
    fill: "#1A1918"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87524 80.2514H-0.000350952V143.28H9.87524V80.2514Z",
    fill: "#1A1918"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.246 50.5995H158.009V82.6298H168.246V50.5995Z",
    fill: "#1A1918"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6264 151.604H19.7508V176.173H29.6264V151.604Z",
    fill: "#1A1918"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M168.246 143.28H178.443V168.006H168.246V143.28Z",
    fill: "#1A1918"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.246 82.6298H178.443V102.846H168.246V82.6298Z",
    fill: "#1A1918"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.502 176.173H29.6264V184.902H39.502V176.173Z",
    fill: "#1A1918"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7508 143.28H9.87524V151.604H19.7508V143.28Z",
    fill: "#1A1918"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.872 177.194H158.009V185.362H148.872V177.194Z",
    fill: "#1A1918"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M158.009 168.006H168.246V177.194H158.009V168.006Z",
    fill: "#1A1918"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.944 184.902H39.502V193.529H48.944V184.902Z",
    fill: "#1A1918"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M138.675 185.362H148.872V193.529H138.675V185.362Z",
    fill: "#1A1918"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2532 193.529H48.944V201.696H59.2532V193.529Z",
    fill: "#1A1918"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M128.382 193.529H138.675V201.696H128.382V193.529Z",
    fill: "#1A1918"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M187.636 102.846H178.443V143.28H187.636V102.846Z",
    fill: "#1A1918"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.78573,
    height: 9.54296,
    transform: "matrix(-1 0 0 1 104.329 120.656)",
    fill: "#1A1918"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.00716,
    height: 8.74771,
    transform: "matrix(-1 0 0 1 139.364 121.451)",
    fill: "#1A1918"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 28.3894,
    height: 7.415,
    transform: "matrix(-1 0 0 1 78.9971 210.934)",
    fill: "#B17C31"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 24.4722,
    height: 7.14647,
    transform: "matrix(-1 0 0 1 141.734 210.885)",
    fill: "#B17C31"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 28.5509,
    height: 8.1674,
    transform: "matrix(-1 0 0 1 132.055 130.35)",
    fill: "#1A1918"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 28.5509,
    height: 9.18832,
    transform: "matrix(-1 0 0 1 78.5146 201.697)",
    fill: "#1A1918"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 27.5312,
    height: 9.18832,
    transform: "matrix(-1 0 0 1 78.5146 218.031)",
    fill: "#1A1918"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5115,
    height: 9.18832,
    transform: "matrix(-1 0 0 1 143.774 218.031)",
    fill: "#1A1918"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.505 8.89844H60.6622V16.9083H48.94V26.0966H60.6669V33.8706H111.456V26.0966H128.475V16.9083H118.505V8.89844ZM95.9375 33.871H60.6675V42.1955H95.9375V33.871Z",
    fill: "#EBBA77"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7649 26.0977H48.942V72.0393H39.7649V26.0977ZM29.5654 34.2656H39.7622V151.606H49.3714V159.929H77.5877V168.253H87.4619V176.578H39.4947V176.174H29.5654V151.605H19.7451V50.5216H29.5654V34.2656ZM19.7439 80.253H9.86896V143.281H19.7439V80.253ZM97.34 176.578V184.341H128.474L128.474 176.174H138.671V168.007L138.671 159.839H168.241V168.007L158.044 168.007V177.195H148.867V185.362H138.671V193.53H128.476V201.697H59.138L59.138 193.53H48.9393V184.903H39.4973V176.578H97.34Z",
    fill: "#B17C31"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 8.1574,
    height: 25.5231,
    transform: "matrix(-1 0 0 1 57.1016 201.697)",
    fill: "#1A1918"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 8.1574,
    height: 24.5022,
    transform: "matrix(-1 0 0 1 80.5547 202.717)",
    fill: "#1A1918"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 7.13772,
    height: 25.5231,
    transform: "matrix(-1 0 0 1 143.774 201.697)",
    fill: "#1A1918"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 7.13772,
    height: 24.5022,
    transform: "matrix(-1 0 0 1 124.4 202.717)",
    fill: "#1A1918"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5115,
    height: 9.18832,
    transform: "matrix(-1 0 0 1 143.774 201.697)",
    fill: "#1A1918"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 140.144,
    y: 75.3281,
    width: 21.0215,
    height: 34.9908,
    fill: "#1A1918"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6211,
    y: 73.7363,
    width: 21.0215,
    height: 34.9908,
    fill: "#1A1918"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7432,
    y: 81.6895,
    width: 10.9,
    height: 14.3144,
    fill: "#F7F4F0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 150.265,
    y: 81.6895,
    width: 10.9,
    height: 14.3144,
    fill: "#F7F4F0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.621 52.9918L196.911 65.579L195.087 69.5962L198.236 71.1026L184.608 101.076L181.393 99.5387L178.067 106.866L174.08 104.956L172.231 109.032L168.256 107.127L166.409 111.196L162.435 109.292L160.587 113.362L153.434 109.936L151.583 114.014L147.608 112.109L146.129 115.368L138.979 111.943L137.128 116.02L122.782 109.149L124.621 105.1L120.662 103.207L125.055 93.5485L111.121 94.7219L111.113 94.6304L104.433 109.323L101.216 107.784L99.7317 111.055L95.7549 109.149L93.9074 113.22L89.9306 111.315L88.0832 115.386L84.106 113.48L82.2589 117.551L75.1055 114.123L73.2545 118.202L69.2836 116.299L67.8051 119.557L60.655 116.131L58.8041 120.208L44.4583 113.337L46.2969 109.288L42.3382 107.395L57.8156 73.3645L61.8309 75.2842L63.6843 71.1995L66.8676 72.725L68.3456 69.4676L72.3178 71.3711L74.1651 67.301L77.3432 68.8236L78.8209 65.5691L89.945 70.8967L91.8002 66.8091L98.9529 70.2359L100.804 66.158L112.765 71.8878L110.927 75.9373L118.061 79.3492L114.956 86.1792L128.942 85.0013L136.139 69.1765L140.154 71.096L142.008 67.0107L145.191 68.536L146.669 65.2779L150.642 67.1817L152.489 63.113L155.67 64.6369L157.148 61.3811L165.1 65.1894L165.521 64.2601L165.506 64.2529L170.621 52.9918ZM172.711 67.7023L170.844 71.8165L170.048 71.4351L168.205 75.4959L161.845 72.4499L160.363 75.7142L152.413 71.9057L150.561 75.9871L147.379 74.4618L145.9 77.7199L141.925 75.8151L135.315 90.3502L135.524 92.6667L134.211 92.7773L129.346 103.474L136.4 106.852L138.255 102.767L143.025 105.052L144.505 101.791L147.684 103.314L149.53 99.2473L157.479 103.054L159.33 98.9736L166.487 102.403L168.339 98.3225L172.314 100.227L176.002 92.0998L179.193 93.6284L187.715 74.8859L172.711 67.7023ZM89.8776 79.6839L91.7299 75.6042L99.6745 79.4103L101.526 75.3303L109.377 79.0912L99.0201 101.87L95.8395 100.346L93.992 104.417L90.0152 102.511L88.1678 106.583L84.191 104.677L82.3438 108.748L78.3667 106.842L76.5158 110.921L69.3624 107.493L67.8785 110.763L59.9309 106.956L58.0771 111.04L51.0226 107.662L63.6015 80.0038L67.5765 81.9087L69.0545 78.6513L72.2378 80.1768L74.0904 76.094L82.0393 79.9022L83.5203 76.6392L89.8776 79.6839Z",
    fill: "#1A1918"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.751 74.9723L184.532 73.4347L184.51 73.4837L172.554 67.7586L170.717 71.8046L169.95 71.4381L168.095 75.5167L161.722 72.4675L160.238 75.7322L152.291 71.93L150.443 75.9954L147.263 74.474L145.785 77.7272L141.814 75.8277L129.294 103.367L136.521 106.824L138.372 102.754L143.144 105.038L144.623 101.784L147.803 103.305L149.656 99.2288L157.603 103.031L159.445 98.977L162.607 100.488L162.609 100.483L166.58 102.38L168.438 98.2942L172.448 100.214L174.283 96.1724L177.419 97.6703L187.751 74.9723ZM67.4874 81.9286L63.49 80.0166L50.9705 107.556L58.1975 111.013L60.05 106.938L67.9979 110.74L69.4792 107.481L76.6277 110.9L78.4725 106.843L82.4298 108.734L84.2801 104.668L88.2559 106.568L90.1052 102.503L94.0801 104.403L95.9263 100.345L99.0953 101.859L109.428 79.1611L106.209 77.6235L106.202 77.6373L101.423 75.3532L99.5741 79.4179L95.5992 77.5182L95.5959 77.5253L91.621 75.6262L89.7655 79.7031L83.396 76.6572L81.9114 79.9219L73.9604 76.1189L72.1213 80.1645L68.9749 78.662L67.4874 81.9286Z",
    fill: "#F4F4F4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1217 50.6738H2.33594V57.0358H6.2288V60.2168H10.1217V62.6025H14.0145V65.7835H18.686V68.9645H22.5788V71.3502H26.4717V74.5312H30.3646V77.7122H34.2574V80.0979H38.1503V83.2789H42.8217V86.4599H46.7146L46.7146 89.6409H54.5003V83.2789L50.6075 83.2789V80.0979H46.7146V77.7122H42.8217V74.5312H38.1503V71.3502H34.2574V68.9645H30.3646V65.7835L26.4717 65.7835V62.6025H22.5788V60.2168H18.686V57.0358H14.0145V53.8548H10.1217V50.6738Z",
    fill: "#1A1918"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5889,
    y: 119.777,
    width: 64,
    height: 86,
    transform: "rotate(45 77.5889 119.777)",
    fill: "#F4F4F4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1245 116.243L126.379 161.497L130.622 165.74L126.379 169.983L66.9823 229.38L62.7397 233.622L8.99959 179.882L13.2422 175.64L72.6392 116.243L76.8818 112L81.1245 116.243ZM62.7397 225.137L122.137 165.74L76.8818 120.485L17.4849 179.882L62.7397 225.137ZM107.287 169.276L110.116 166.447L76.1747 132.506L73.3463 135.335L107.287 169.276ZM104.459 172.104L101.631 174.933L67.6894 140.991L70.5179 138.163L104.459 172.104ZM78.296 162.912L81.1245 160.083L64.861 143.82L62.0326 146.648L78.296 162.912Z",
    fill: "#1A1918"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 25.8142,
    height: 9.30825,
    transform: "matrix(-1 0 0 1 62.4072 153.906)",
    fill: "#1A1918"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 6.94997,
    height: 25.8563,
    transform: "matrix(-1 0 0 1 62.4072 137.357)",
    fill: "#1A1918"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 6.94997,
    height: 24.822,
    transform: "matrix(-1 0 0 1 43.543 138.393)",
    fill: "#1A1918"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 25.8142,
    height: 9.30825,
    transform: "matrix(-1 0 0 1 62.4072 137.357)",
    fill: "#1A1918"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 145,
    width: 16,
    height: 10,
    fill: "#D59F52"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 4.49135,
    height: 4.49135,
    transform: "matrix(0.699576 0.714558 -0.699576 0.714558 195.973 34.7695)",
    fill: "#F86C14"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 4.49135,
    height: 4.49135,
    transform: "matrix(-0.699576 0.714558 0.699576 0.714558 206.899 156.441)",
    fill: "#F86C14"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 8.57786,
    height: 8.57786,
    transform: "matrix(0.699576 0.714558 -0.699576 0.714558 210.538 34.7695)",
    fill: "#F86C14"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 8.57786,
    height: 8.57786,
    transform: "matrix(-0.699576 0.714558 0.699576 0.714558 195.973 157.238)",
    fill: "#F86C14"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 16.5346,
    height: 16.5346,
    transform: "matrix(-0.699576 0.714558 0.699576 0.714558 213.216 118.27)",
    fill: "#F86C14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotatoCharacterPm);
export default __webpack_public_path__ + "static/media/cotato_character_pm.9ae8db7b8c50aff16682847a89916989.svg";
export { ForwardRef as ReactComponent };